export default __webpack_public_path__ + "static/media/image1.5d97f386.png";